module.exports = __webpack_public_path__ + "static/emmerdale-studio-experience-f65161c337e0dc04b70a9548ec3809f0.jpg";